import React, { createContext, useContext, useEffect, useState } from 'react';

export type ThemeMode = 'classic' | 'v2';

interface ThemeContextType {
    themeMode: ThemeMode;
    setThemeMode: (_mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
    const [themeMode, setThemeMode] = useState<ThemeMode>(() => {
        const saved = localStorage.getItem('tipsnorge-theme-mode');
        return (saved === 'v2' || saved === 'classic') ? saved : 'classic';
    });

    useEffect(() => {
        localStorage.setItem('tipsnorge-theme-mode', themeMode);
        
        // We can also toggle a class on the body if needed for global v2 styles
        if (themeMode === 'v2') {
            document.body.classList.add('theme-v2');
        } else {
            document.body.classList.remove('theme-v2');
        }
    }, [themeMode]);

    return (
        <ThemeContext.Provider value={{ themeMode, setThemeMode }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
